export default "__VITE_ASSET__VcAV_RQj__"